/* DEMO product page tabs v5 (29 Oct): own full-width tabs, lighter underline style with small icons and the live Feefo review count. Markup in templates/product.liquid (#dc-tabs). Description collapses with Show more; Delivery and Support are short summaries; Feefo panel is height-limited. On phones the tabs scroll sideways and the open tab is kept in view. */
(function () {
  'use strict';
  var box = document.getElementById('dc-tabs');
  if (!box) return;

  var css = document.createElement('style');
  css.textContent =
    '#dc-tabs{clear:both;float:none;width:100%;box-sizing:border-box;margin:36px 0 10px;padding:0 15px}' +
    '#dc-tabs .dc-tl{display:flex;gap:4px;margin:0;padding:0;border-bottom:2px solid #eadfce;overflow-x:auto;overflow-y:hidden;scrollbar-width:none;-webkit-overflow-scrolling:touch}' +
    '#dc-tabs .dc-tl::-webkit-scrollbar{display:none}' +
    '#dc-tabs .dc-tb{flex:1 1 0;display:flex;align-items:center;justify-content:center;gap:9px;appearance:none;-webkit-appearance:none;background:transparent;color:#8c7762;border:0;border-bottom:3px solid transparent;border-radius:10px 10px 0 0;padding:15px 12px 13px;margin:0 0 -2px;font:inherit;font-size:15px;font-weight:700;letter-spacing:.1px;white-space:nowrap;cursor:pointer;transition:background .15s,color .15s,border-color .15s}' +
    '#dc-tabs .dc-tb i{font-size:17px;line-height:1;color:#c9bba7;transition:color .15s}' +
    '#dc-tabs .dc-tb:hover{background:#f6efe4;color:#392919}' +
    '#dc-tabs .dc-tb:hover i{color:#eb6035}' +
    '#dc-tabs .dc-tb.dc-on{background:transparent;color:#392919;border-bottom-color:#eb6035;font-weight:800}' +
    '#dc-tabs .dc-tb.dc-on i{color:#eb6035}' +
    '#dc-tabs .dc-tb:focus-visible{outline:3px solid #eb6035;outline-offset:-3px}' +
    '#dc-tabs .dc-cnt{padding:2px 8px;border-radius:999px;background:#f6efe4;color:#6f675d;font-size:12px;font-weight:700;line-height:1.3}' +
    '#dc-tabs .dc-tp{background:#fff;border:1px solid #eadfce;border-top:0;border-radius:0 0 14px 14px;padding:26px 28px;color:#392919;box-sizing:border-box;width:100%}' +
    '#dc-tabs .dc-tp.dc-off{display:none}' +
    '#dc-tabs #dc-tp-reviews.dc-off{display:block;height:0;overflow:hidden;visibility:hidden;padding:0;border:0}' +
    '#dc-tabs .dc-tp img{max-width:100%;height:auto}' +
    '#dc-tabs .dc-clip{position:relative;max-height:260px;overflow:hidden}' +
    '#dc-tabs .dc-clip:after{content:\"\";position:absolute;left:0;right:0;bottom:0;height:90px;background:linear-gradient(rgba(255,255,255,0),#fff);pointer-events:none}' +
    '#dc-tabs .dc-more,#dc-tabs .dc-go{display:inline-block;margin:14px auto 0;appearance:none;-webkit-appearance:none;background:#fff;color:#392919;border:2px solid #eb6035;border-radius:999px;padding:10px 26px;font:inherit;font-size:15px;font-weight:800;cursor:pointer;text-decoration:none}' +
    '#dc-tabs .dc-more{display:block}' +
    '#dc-tabs .dc-more:hover,#dc-tabs .dc-go:hover{background:#eb6035;color:#fff;text-decoration:none}' +
    '#dc-tabs .dc-dl{display:grid;grid-template-columns:repeat(auto-fit,minmax(190px,1fr));gap:12px;margin:0 0 6px}' +
    '#dc-tabs .dc-dc{border:1px solid #eadfce;border-radius:12px;padding:12px 14px;background:#faf8f4}' +
    '#dc-tabs .dc-dc b{display:block;font-size:15px;color:#392919}' +
    '#dc-tabs .dc-dc span{display:block;font-size:13px;color:#6f675d;margin-top:2px}' +
    '#dc-tabs .dc-dc em{display:block;font-style:normal;font-size:20px;font-weight:900;color:#eb6035;margin-top:6px}' +
    '#dc-tabs .dc-note{margin:10px 0 0;font-size:13px;color:#6f675d}' +
    '#dc-tabs .dc-ph{font-size:22px;font-weight:900;color:#eb6035;text-decoration:none}' +
    '#dc-tabs #dc-tp-reviews .feefo-review-widget-product{max-height:340px;overflow-y:auto;overflow-x:hidden}' +
    '@media(max-width:700px){#dc-tabs{padding:0 10px}#dc-tabs .dc-tb{flex:0 0 auto;padding:14px 16px 12px;font-size:14px}#dc-tabs .dc-tp{padding:18px 16px}#dc-tabs .dc-clip{max-height:220px}}';
  document.head.appendChild(css);

  var tabs = [].slice.call(box.querySelectorAll('.dc-tb'));
  var tl = box.querySelector('.dc-tl');
  var ICON = { description: 'fa-file-text-o', delivery: 'fa-truck', reviews: 'fa-star', support: 'fa-phone', share: 'fa-share-alt' };
  tabs.forEach(function (b) {
    var ic = ICON[b.getAttribute('data-tab')];
    if (!ic || b.querySelector('i')) return;
    var i = document.createElement('i');
    i.className = 'fa ' + ic; i.setAttribute('aria-hidden', 'true');
    b.insertBefore(i, b.firstChild);
  });

  /* live Feefo review count on the Reviews tab, read from the stars widget once it has loaded */
  var rb = box.querySelector('.dc-tb[data-tab="reviews"]'), cnt = null;
  function readCount() {
    var s = document.querySelector('.feefo-product-stars-widget');
    var m = s && /\((\d[\d,]*)\)/.exec(s.textContent || '');
    if (!m || !rb) return;
    if (!cnt) { cnt = document.createElement('span'); cnt.className = 'dc-cnt'; rb.appendChild(cnt); }
    cnt.textContent = m[1];
  }
  readCount();
  [800, 2000, 4000, 8000].forEach(function (ms) { setTimeout(readCount, ms); });
  var sw = document.querySelector('.feefo-product-stars-widget');
  if (sw && window.MutationObserver) {
    var rt = null, mo = new MutationObserver(function () { clearTimeout(rt); rt = setTimeout(readCount, 150); });
    mo.observe(sw, { childList: true, subtree: true, characterData: true });
    setTimeout(function () { mo.disconnect(); }, 15000);
  }

  function open(key, focus) {
    tabs.forEach(function (b) {
      var on = b.getAttribute('data-tab') === key;
      b.classList.toggle('dc-on', on);
      b.setAttribute('aria-selected', on ? 'true' : 'false');
      b.tabIndex = on ? 0 : -1;
      var p = document.getElementById('dc-tp-' + b.getAttribute('data-tab'));
      if (p) p.classList.toggle('dc-off', !on);
      if (on && focus) b.focus();
      if (on && tl && tl.scrollWidth > tl.clientWidth + 2) tl.scrollLeft = b.offsetLeft - (tl.clientWidth - b.offsetWidth) / 2;
    });
    if (key === 'description') fit();
  }
  tabs.forEach(function (b, i) {
    b.addEventListener('click', function () { open(b.getAttribute('data-tab')); });
    b.addEventListener('keydown', function (e) {
      var d = e.key === 'ArrowRight' ? 1 : e.key === 'ArrowLeft' ? -1 : 0;
      if (!d) return;
      e.preventDefault();
      open(tabs[(i + d + tabs.length) % tabs.length].getAttribute('data-tab'), true);
    });
  });

  var desc = document.getElementById('product-description');
  var btn = null, expanded = false;
  function fit() {
    if (!desc || expanded) return;
    desc.classList.remove('dc-clip');
    var h = desc.scrollHeight;
    var lim = window.innerWidth <= 700 ? 220 : 260;
    if (h > lim + 60) {
      desc.classList.add('dc-clip');
      if (!btn) {
        btn = document.createElement('button');
        btn.type = 'button'; btn.className = 'dc-more'; btn.textContent = 'Show more';
        btn.setAttribute('aria-expanded', 'false');
        btn.addEventListener('click', function () {
          expanded = !expanded;
          desc.classList.toggle('dc-clip', !expanded);
          btn.textContent = expanded ? 'Show less' : 'Show more';
          btn.setAttribute('aria-expanded', expanded ? 'true' : 'false');
          if (!expanded) { fit(); var y = box.getBoundingClientRect().top + window.pageYOffset - 80; window.scrollTo({ top: y, behavior: 'smooth' }); }
        });
        desc.parentNode.appendChild(btn);
      }
      btn.style.display = '';
    } else if (btn) btn.style.display = 'none';
  }
  function refit() { if (expanded) { desc.classList.remove('dc-clip'); return; } fit(); }
  open('description');
  window.addEventListener('load', refit);
  window.addEventListener('resize', refit);
  setTimeout(refit, 600);

  window.dcOpenTab = function (k) {
    open(k);
    var y = box.getBoundingClientRect().top + window.pageYOffset - 80;
    window.scrollTo({ top: y, behavior: 'smooth' });
  };
  var stars = document.querySelector('.feefo-product-stars-widget');
  if (stars) stars.addEventListener('click', function (e) { e.stopImmediatePropagation(); window.dcOpenTab('reviews'); }, true);
})();